<template>
<el-scrollbar class="paper-template">
  <el-breadcrumb separator-class="el-icon-arrow-right" class="genera-breadcrumb">
    <el-breadcrumb-item>组卷概率</el-breadcrumb-item>
    <el-breadcrumb-item>创建试卷模板</el-breadcrumb-item>
  </el-breadcrumb>
  <div class="steps-wrapper">
    <div class="step-item" :class="{current: [1, 2].includes(stepActive)}">
      <div class="step-line"></div>
      <div class="step-text">1</div>
      <div class="step-title">创建试卷</div>
    </div>
    <div class="step-item" :class="{current: [2].includes(stepActive)}">
      <div class="step-line"></div>
      <div class="step-text">2</div>
      <div class="step-title">创建成功</div>
    </div>
  </div>
  <div class="steps-one-content" v-if="stepActive === 1">
    <el-form ref="paperForm" :model="paperForm" :rules="paperFormRules" label-width="80px" style="margin-left: 30px">
      <el-form-item label="试卷名称" prop="name">
        <el-input v-model="paperForm.name" style="width: 420px;" ref="cursorInput" placeholder="2-18"></el-input>
      </el-form-item>
      <el-form-item label="考试分类" prop="category_id">
        <el-cascader v-model="paperForm.category_id" style="width: 420px" :props="keyObj" :options="gradeClassList"
                     placeholder="请选择试卷分类" @change="selectPaper"></el-cascader>
      </el-form-item>
      <el-form-item label="理论题" required>
        <el-col :span="30">
          <el-form-item prop="theory_id">
            <el-select @change="selectTheory" v-model="paperForm.theory_id" style="width: 420px;" placeholder="选择试卷名称">
              <el-option
                  v-for="item in theoryList"
                  :key="item.theory_test_paper_id"
                  :label="item.theory_test_paper_name"
                  :value="item.theory_test_paper_id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="25">
          <el-form-item prop="theory_score">
            <el-input-number :controls="false" :disabled="true" v-model="paperForm.theory_score" style="width: 100px;margin-left: 16px" placeholder="设置分值"></el-input-number>   分
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label="实操题" required>
        <el-col :span="30">
          <el-form-item prop="practic_id">
            <el-select @change="selectPractic" style="width: 420px;" v-model="paperForm.practic_id" placeholder="选择试卷名称">
              <el-option
                  v-for="item in practicalList"
                  :key="item.id"
                  :label="item.op_name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="30">
          <el-form-item prop="practic_score">
            <el-input-number :controls="false" :disabled="true" v-model="paperForm.practic_score" style="width: 100px;margin-left: 16px" placeholder="设置分值"></el-input-number>   分
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label="理论题" prop="theory_rate">
        <el-input-number :min="1" :precision="0" :controls="false" v-model="paperForm.theory_rate" style="width: 100px;" placeholder="设置分值比例"></el-input-number> %
      </el-form-item>
      <el-form-item label="实操题" prop="practic_rate">
        <el-input-number :min="1" :precision="0" :controls="false" v-model="paperForm.practic_rate" style="width: 100px;" placeholder="设置分值比例"></el-input-number> %
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button @click="toBack">返回</el-button>
      <el-button style="margin-left: 20px" type="primary" @click="nextStep('paperForm')">下一步</el-button>
    </div>
  </div>
  <div class="steps-two-content" v-if="stepActive === 2">
    <img src="./../../../assets/images/admin/createSuccess.png" alt="">
    <span>创建成功</span>
    <el-button @click="toBack">返回列表</el-button>
  </div>
</el-scrollbar>
</template>

<script>
import {paperSavePaper, paperGetPaper, theoryTestPaperGetList, operationProblemOpEpList, catePage, paperGetKefuTopic, theoryTestPaperGetNameByCategory, operationProblemCustomerServiceList} from '@/utils/apis'
export default {
  name: "AddPaperTemplate",
  data(){
    return {
      //步骤
      stepActive: 1,
      paperForm:{
        id:'',
        name:'',
        category_id:'',
        theory_id:'',
        theory_score:void 0,
        practic_id:'',
        practic_score:void 0,
        theory_rate:void 0,
        practic_rate:void 0,
      },
      paperFormRules:{
        name:[
          { required: true, message: '请输入试卷名称', trigger: 'blur' },
          { min: 2, max: 18, message: '长度在 2 到 18 个字', trigger: 'blur' }
        ],
        category_id:[
          { required: true, message: '请选择考试分类', trigger: 'change' }
        ],
        theory_id:[
          { required: true, message: '请选择理论题', trigger: 'change' }
        ],
        practic_id:[
          { required: true, message: '请选择实操题', trigger: 'change' }
        ],
        theory_rate:[
          { required: true, message: '请输入理论题分值比', trigger: 'blur' },
        ],
        practic_rate:[
          { required: true, message: '请输入实操题分值比', trigger: 'blur' },
        ]
      },
      keyObj:{
        label: 'name',
        value: 'id',
        children: 'children'
      },
      gradeClassList:[],
      theoryList:[],
      practicalList:[],
    }
  },
  mounted() {
    this.getCatePage();
    if(this.$route.query.id){
      this.getEditData(this.$route.query.id)
    }
  },
  methods:{
    // 获取试卷分类
    getCatePage(){
      let params = {
        type:3
      }
      catePage(params).then((res)=>{
        this.gradeClassList = res.data.list;
      }).catch((err)=>{
        console.log('err',err)
      })
    },
    // 筛选试卷
    selectPaper(val){
      this.paperForm.theory_id = '';
      this.paperForm.practic_id = '';
      this.getOperationProblemOpEpList();
      this.getTheoryTestPaperGetList();
    },
    getEditData(id){
      let params = {
        id:id
      }
      paperGetPaper(params).then((res)=>{
        this.paperForm.id = res.data.id;
        this.paperForm.name = res.data.name;
        this.paperForm.category_id = [res.data.category_id1,res.data.category_id2,res.data.category_id3];
        this.paperForm.theory_rate = res.data.theory_rate;
        this.paperForm.practic_rate = res.data.practic_rate;
        this.getTheoryTestPaperGetList();
        this.getOperationProblemOpEpList();
        this.paperForm.theory_id = res.data.theory_id;
        this.paperForm.theory_score = res.data.theory_score;
        this.paperForm.practic_id = res.data.practic_id;
        this.paperForm.practic_score = res.data.practic_score
      }).catch((err)=>{
        console.log('err', err)
      })
    },
    // 获取理论试卷
    getTheoryTestPaperGetList(){
      let params = {
        category_id:this.paperForm.category_id[this.paperForm.category_id.length - 1],
      }
      theoryTestPaperGetNameByCategory(params).then((res)=>{
        this.theoryList = res.data;
      }).catch((err)=>{
        console.log('err',err)
      })
    },
    // 获取实操试卷
    getOperationProblemOpEpList(){
      let params = {
        category_id:this.paperForm.category_id[this.paperForm.category_id.length - 1],
      }
      operationProblemCustomerServiceList(params).then((res)=>{
        this.practicalList = res.data;
      }).catch((err)=>{
        console.log('err',err)
      })
    },
    // 选择理论题
    selectTheory(val){
      this.paperForm.theory_score = void 0;
      this.theoryList.forEach(item=>{
        if(item.theory_test_paper_id === val){
          this.paperForm.theory_score = item.score;
          return;
        }
      })
    },
    // 选择实操题
    selectPractic(val){
      this.paperForm.practic_score = void 0;
      this.practicalList.forEach(item=>{
        if(item.id === val){
          this.paperForm.practic_score = item.score;
          return;
        }
      })
    },
    nextStep(formName){
      this.$refs[formName].validate((valid)=>{
        if(valid){
          if(this.paperForm.theory_rate + this.paperForm.practic_rate !== 100){
            this.$message.warning('理论题和实操题分值比之和必须是100');
            return
          }
          let formData = new FormData();
          formData.append('name', this.paperForm.name);
          formData.append('category_id', this.paperForm.category_id[this.paperForm.category_id.length - 1]);
          formData.append('theory_id', this.paperForm.theory_id);
          formData.append('theory_rate', this.paperForm.theory_rate);
          formData.append('theory_score', this.paperForm.theory_score);
          formData.append('practic_id', this.paperForm.practic_id);
          formData.append('practic_rate', this.paperForm.practic_rate);
          formData.append('practic_score', this.paperForm.practic_score);
          if(this.paperForm.id){
            formData.append('id',this.paperForm.id)
          }
          paperSavePaper(formData).then((res)=>{
            this.$message.success(res.msg);
            this.stepActive++
          }).catch((err)=>{
            console.log('err', err)
          })
        } else {
          return false;
        }
      })
    },
    toBack(){
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="scss">
.paper-template{
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
    .el-scrollbar__view {
      padding: 0px 20px;
    }
  }
  .steps-one-content{
    margin-top: 50px;
    //padding: 0 30px;
    box-sizing: border-box;
    .dialog-footer{
      margin: 80px 0 80px 6px;
    }
  }
  .steps-two-content{
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img{
      max-height: 240px;
      max-width: 240px;
    }
    span{
      font-size: 24px;
      line-height: 1;
      margin-top: 32px;
    }
    .el-button{
      margin: 36px 0;
    }
  }
}
</style>